const LocationReviewsData = [
  {
    customer: "Michael S.",
    review: "Fantastic service! The team quickly diagnosed our HVAC issue and had it fixed within hours. House is cool again!",
    service: "HVAC Repair"
  },
  {
    customer: "Jessica T.",
    review: "AttiAir replaced our old AC unit and the new system works perfectly. Very professional and clean install.",
    service: "AC Installation"
  },
  {
    customer: "Emily R.",
    review: "Quick response, friendly techs, and honest pricing. Our furnace was up and running the same day.",
    service: "Furnace Repair"
  },
  {
    customer: "Anthony J.",
    review: "Highly skilled and courteous. They handled our full HVAC replacement and made the process stress-free.",
    service: "HVAC Replacement"
  },
  {
    customer: "Robert K.",
    review: "Had issues with inconsistent airflow. AttiAir balanced the system and it feels great in every room now.",
    service: "Airflow Repair"
  },
  {
    customer: "Sarah P.",
    review: "Great work installing our new ductless mini split. Super efficient and looks great too.",
    service: "Mini Split Installation"
  },
  {
    customer: "Lisa M.",
    review: "Very professional team. They showed up on time, explained everything, and completed the HVAC install smoothly.",
    service: "HVAC System Installation"
  },
  {
    customer: "Kevin H.",
    review: "Our old unit failed on a weekend. AttiAir came out quickly and made the emergency repair. So grateful!",
    service: "Emergency HVAC Repair"
  },
  {
    customer: "Diana F.",
    review: "Awesome team! They fixed a broken blower motor and now the heat works perfectly again.",
    service: "Blower Motor Repair"
  },
  {
    customer: "Eric W.",
    review: "AttiAir delivered top-notch service when replacing our HVAC. Everything runs quieter and more efficiently.",
    service: "HVAC System Replacement"
  },
  {
    customer: "Samantha L.",
    review: "Our thermostat kept failing. They installed a smart thermostat and now everything runs better.",
    service: "Thermostat Installation"
  },
  {
    customer: "Tom C.",
    review: "Called them for furnace troubleshooting. They found the problem fast and fixed it same-day.",
    service: "Furnace Diagnosis & Repair"
  },
  {
    customer: "Olivia N.",
    review: "We upgraded our entire HVAC system with AttiAir. Very happy with the result and the professionalism.",
    service: "HVAC Upgrade"
  },
  {
    customer: "Jason B.",
    review: "The tech knew exactly what was wrong. Quick coil replacement and cold air is back!",
    service: "AC Coil Replacement"
  },
  {
    customer: "Maria S.",
    review: "Our home wasn’t cooling evenly. They adjusted the vents and now every room feels just right.",
    service: "Airflow Balancing"
  },
  {
    customer: "Peter V.",
    review: "Reliable, fast, and affordable HVAC service. I’ll definitely use them again.",
    service: "HVAC Repair"
  },
  {
    customer: "Vanessa D.",
    review: "AttiAir helped us choose the right HVAC system for our home and installed it flawlessly.",
    service: "System Design & Installation"
  },
  {
    customer: "Ben A.",
    review: "We had ongoing HVAC issues that others couldn’t solve. AttiAir fixed it in one visit. Impressive!",
    service: "System Troubleshooting"
  },
  {
    customer: "Amy G.",
    review: "From booking to installation, the process was smooth. The crew was respectful and worked fast.",
    service: "Furnace Installation"
  },
  {
    customer: "Rachel K.",
    review: "Excellent work! They replaced our outdated AC with a modern unit that cools better and saves energy.",
    service: "AC Replacement"
  }
];

export default LocationReviewsData;
